module.exports = __webpack_public_path__ + "static/media/about-image.1050e212.png";